// https://swiperjs.com/get-started
import SwiperCore, { Navigation, Pagination, Scrollbar, Autoplay, EffectFade } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade]);
import 'swiper/swiper-bundle.css';

if ($('.swiper-container').length) {
	const swiper = new SwiperCore('.swiper-container', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,

		// If we need pagination
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

		// Navigation arrows
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		// And if we need scrollbar
		scrollbar: {
			el: '.swiper-scrollbar',
		},
	});
}

if ($('.swiper-container-cover').length) {
	const swiperCover = new SwiperCore('.swiper-container-cover', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		speed: 800,
		autoplay: {
			delay: 5000,
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
	});
}
